import '../index_web.css';
import FlatList from 'flatlist-react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import {
  EmptyData,
  ErrorMessage,
  FlatListWrapper,
  PlaceHolder,
  TransactionGameItem,
  View,
  PaginationIndicator,
  TransactionHeaderGameItem
} from '../../../../component';
import useTheme from '../../../../utilities/hooks/theme';

const GameHistoryWeb = ({
  error,
  resultArrived,
  _onRefresh,
  hasMoreItems,
  loadMoreItems,
  gameTransactionList,
  onPressRetryGame
}: any) => {
  const { AccountTheme: theme } = useTheme();
  const PrimaryDetailsContainerStyle = {
    background: theme.transactionHistoryGameHeaderBg,
    boxShadow: theme.transactionHistoryGameHeaderBoxShadow,
    border: `1px solid ${theme.transactionHistoryBorder}`
  };
  const secondaryContainerStyle = {
    background: theme.transactionHistoryGameContentBg,
    boxShadow: theme.transactionHistoryGameContentBoxShadow,
    borderLeft: `1px solid ${theme.transactionHistoryBorder}`,
    borderBottom: `1px solid ${theme.transactionHistoryBorder}`,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };

  const renderSectionItem = (item: any) => {
    const { header = {}, data = [] } = item;

    return (
      <>
        <View className="transactionGamesHistory__details__wrapper">
          <div
            className="transactionGamesHistory__details__primary__container"
            style={PrimaryDetailsContainerStyle}>
            {data.map((item: any, idx: any) => (
              <div
                style={{
                  width: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  borderRight: idx == 0 ? `2px solid ${theme.transactionHistoryBorder}` : '',
                  padding: '10px'
                }}
                key={idx}>
                <TransactionGameItem item={item} />
              </div>
            ))}
          </div>
          <div
            className="transactionGamesHistory__details__secondary__container"
            style={secondaryContainerStyle}>
            <TransactionHeaderGameItem item={header} />
          </div>
        </View>
      </>
    );
  };

  const renderWhenEmpty = () => {
    if (error) return <ErrorMessage onPressRetry={onPressRetryGame} />;
    if (!resultArrived) return <PlaceHolder.Loader />;
    return <EmptyData message={'No Games Transaction found'} />;
  };

  return (
    <View className={'transaction-history-container'}>
      <PullToRefresh onRefresh={_onRefresh}>
        <FlatListWrapper>
          <FlatList
            renderItem={renderSectionItem}
            list={gameTransactionList}
            renderWhenEmpty={renderWhenEmpty}
            hasMoreItems={hasMoreItems}
            loadMoreItems={loadMoreItems}
            // renderOnScroll
            paginationLoadingIndicator={<PaginationIndicator />}
          />
        </FlatListWrapper>
      </PullToRefresh>
    </View>
  );
};
export default GameHistoryWeb;
